import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Icon, Button } from 'semantic-ui-react';
import ReactJson from '@microlink/react-json-view';

const JsonViewerModal = ({ data, header = 'JSON', icon = 'file alternate' }) => (
  <Modal
    trigger={<Icon link size='large' name={icon} title={header}/>}
    header={
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px' }}>
        <span>{header}</span>
        <Button
          icon='copy'
          size='tiny'
          title='Copy JSON'
          onClick={() => navigator.clipboard.writeText(JSON.stringify(data, null, 2))}
        />
      </div>
    }
    content={
      <Modal.Content style={{ maxHeight: 600, display: 'flex' }}>
        <ReactJson
          src={data}
          style={{ width: '100%', height: 400, overflow: 'auto' }}
        />
      </Modal.Content>
    }
  />
);

JsonViewerModal.propTypes = {
  data: PropTypes.any,
  header: PropTypes.string,
  icon: PropTypes.string
};

export default JsonViewerModal;
